var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m19.9498 11.1109c.2929-.2929.2929-.7678 0-1.0607-.2929-.29286-.7678-.29286-1.0607 0l-3.8891 3.8891-3.8891-3.8891c-.2929-.29286-.7677-.29286-1.0606 0-.29293.2929-.29293.7678 0 1.0607l3.8891 3.8891-3.8891 3.8891c-.29293.2929-.29293.7677 0 1.0606.2929.2929.7677.2929 1.0606 0l3.8891-3.8891 3.8891 3.8891c.2929.2929.7678.2929 1.0607 0s.2929-.7677 0-1.0606l-3.8891-3.8891z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCross);
export default __webpack_public_path__ + "static/media/icon_cross.3356837af95aa2039e99dced70d35e18.svg";
export { ForwardRef as ReactComponent };